import {IconProps, darkGray, gray, white, yellow} from './shared';

export const Good = ({selected}: IconProps) => {
  const backgroundColor = selected ? yellow : gray;
  const foregroundColor = selected ? darkGray : white;
  const backgroundOpacity = selected ? '1.0' : '0.7';

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z"
        fill={backgroundColor}
        opacity={backgroundOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6251 26.531C14.1756 26.0188 12.9211 25.4051 12.2321 25.0114C11.6327 24.6688 10.8691 24.8771 10.5266 25.4765C10.1841 26.0759 10.3923 26.8395 10.9917 27.182C11.808 27.6484 13.1987 28.3251 14.7922 28.8881C16.373 29.4467 18.2469 29.9273 19.999 29.9273C21.7511 29.9273 23.625 29.4467 25.2058 28.8881C26.7993 28.3251 28.1899 27.6484 29.0063 27.182C29.6057 26.8395 29.8139 26.0759 29.4714 25.4765C29.1289 24.8771 28.3653 24.6688 27.7659 25.0114C27.0769 25.4051 25.8224 26.0188 24.3729 26.531C22.9106 27.0477 21.3436 27.4273 19.999 27.4273C18.6543 27.4273 17.0873 27.0477 15.6251 26.531Z"
        fill={foregroundColor}
      />
      <path
        d="M15.4829 13.8386C15.4829 15.6202 14.0386 17.0644 12.2571 17.0644C10.4755 17.0644 9.03125 15.6202 9.03125 13.8386C9.03125 12.057 10.4755 10.6128 12.2571 10.6128C14.0386 10.6128 15.4829 12.057 15.4829 13.8386Z"
        fill={foregroundColor}
      />
      <path
        d="M30.9667 13.8386C30.9667 15.6202 29.5225 17.0644 27.7409 17.0644C25.9594 17.0644 24.5151 15.6202 24.5151 13.8386C24.5151 12.057 25.9594 10.6128 27.7409 10.6128C29.5225 10.6128 30.9667 12.057 30.9667 13.8386Z"
        fill={foregroundColor}
      />
    </svg>
  );
};
